import { inject, Injectable } from '@angular/core';
import {
  FormBuilder,
  FormGroup,
  ValidatorFn,
  FormControl,
  Validators,
} from '@angular/forms';
import { IRegistroUsuarioForm } from '../../interfaces/consulta-externa-pqrs.interface';

@Injectable({ providedIn: 'root' })
export class FormBuilderService {
  private fb = inject(FormBuilder);

  private form!: FormGroup<IRegistroUsuarioForm>;

  buildForm(): FormGroup<IRegistroUsuarioForm> {
    this.form = this.fb.group<IRegistroUsuarioForm>({
      // Datos personales
      CodTipoDocumento: this.createControl<number | null>(
        null,
        Validators.required
      ),
      NumeroDocumento: this.createControl<number | null>(null),
      PrimerNombre: this.createControl<string | null>(
        null,
        Validators.required
      ),
      SegundoNombre: this.createControl<string | null>(null),
      PrimerApellido: this.createControl<string | null>(
        null,
        Validators.required
      ),
      SegundoApellido: this.createControl<string | null>(null),
      CodGenero: this.createControl<string | null>(null),
      RazonSocial: this.createControl<string | null>(null),

      // Contacto
      Email: this.createControl<string | null>(null, [
        Validators.required,
        Validators.email,
      ]),
      Celular: this.createControl<string | null>(null, Validators.required),
      CodGlobal: this.createControl<string | null>(null, Validators.required),
      Direccion: this.createControl<string | null>(null, Validators.required),
      codUserUpdate:this.createControl<string | null>(null),
      });
    return this.form;
  }

  private createControl<T>(
    value: T | { value: T | null; disabled: boolean } | null,
    validators?: ValidatorFn | ValidatorFn[] | null
  ): FormControl<T | null> {
    return this.fb.control(value, validators);
  }

    getErrorMessage(field: string): string {
    const control = this.form.get(field);
    if (!control?.errors) return '';
    const errors = control.errors;

    if (errors['required']) return `${this.getFieldDisplayName(field)} es obligatorio`;
    if (errors['minlength']) return `${this.getFieldDisplayName(field)} debe tener al menos ${errors['minlength'].requiredLength} caracteres`;
    if (errors['maxlength']) return `${this.getFieldDisplayName(field)} no puede tener más de ${errors['maxlength'].requiredLength} caracteres`;
    if (errors['min']) return `${this.getFieldDisplayName(field)} debe ser mayor a ${errors['min'].min}`;

    return 'Campo inválido';
  }
    private getFieldDisplayName(fieldName: string): string {
    const displayNames: Record<string, string> = {
      Id: 'Id',
      nombre: 'Nombre',
      estado: 'Estado',
      observacion: 'Observación',
    };
    return displayNames[fieldName] || fieldName;
  }
}
